import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getProItemLedger = createAsyncThunk('/prosafe/getProItemLedger',
    async ({ formData }) => {
        try {
            const myurl = `${V_URL}/prosafe/pro-item-ledger-list`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: formData,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN'),
                },
            });

            const data = response.data;
            // console.log(data, "getProItemLedger response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message || "Failed to load item ledger");
            return error;
        }
    })

const getProItemLedgerSlice = createSlice({
    name: "getProItemLedger",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProItemLedger.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProItemLedger.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getProItemLedger.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getProItemLedgerSlice.reducer;